import { useQuery, UseQueryOptions } from 'react-query';

import { LandingApi, LandingPopunder } from 'api/LandingApi';

export const useLandingPopunderQuery = (
  queryOptions?: UseQueryOptions<LandingPopunder>
) => {
  const landingPopunderQueryKey = 'landing-popunder-query';

  const landingPopunderQuery = useQuery<LandingPopunder>(
    landingPopunderQueryKey,
    LandingApi.fetchPopunderData,
    {
      retry: false,
      cacheTime: 0,
      ...queryOptions,
    }
  );

  return {
    landingPopunderQueryKey,
    landingPopunderQuery,
  };
};
